import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { PageSEO } from '@/components/SEO';
import { blogPosts } from '@/data/blogPosts';

function formatDate(dateStr) {
  const [year, month, day] = dateStr.split('-');
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('nb-NO', { day: 'numeric', month: 'long', year: 'numeric' });
}

export default function Blogg() {
  const sortedPosts = [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div>
      <PageSEO
        title="Blogg – Tips om digital vekst og SEO i Norge"
        path="/blogg"
        description="Få gratis innsikt og tips om hvordan du kan vokse din bedrift digitalt i Norge. Vi skriver om SEO, webutvikling, Google Ads og mer."
      />
      {/* Hero */}
      <section className="pt-16 md:pt-20 pb-16 md:pb-20 bg-muted" data-testid="blogg-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <p className="font-manrope text-xs font-medium tracking-[0.3em] uppercase text-accent mb-4">
              Blogg & Innsikt
            </p>
            <h1 className="font-syne font-bold text-5xl md:text-6xl text-primary tracking-tight leading-[0.95]">
              Slik lykkes du på nett i 2026
            </h1>
            <p className="font-manrope text-lg text-muted-foreground mt-8 leading-relaxed">
              Vi deler våre beste strategier for digital markedsføring, SEO og webutvikling for norske bedrifter. Få overtaket på konkurrentene helt gratis.
            </p>
          </div>
        </div>
      </section>

      {/* Artikler */}
      <section className="py-24 md:py-32" data-testid="blogg-liste">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            {sortedPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blogg/${post.slug}`}
                className="group bg-card border border-border/50 p-8 rounded-2xl shadow-sm hover:shadow-xl hover:border-accent/50 transition-all duration-500 block relative overflow-hidden ring-1 ring-primary/5"
                data-testid={`blog-post-${post.slug}`}
              >
                <div className="flex items-center gap-3 text-muted-foreground mb-6">
                  <div className="bg-accent/10 p-2 rounded-lg">
                    <Calendar className="w-4 h-4 text-accent" />
                  </div>
                  <span className="font-manrope text-sm">{formatDate(post.date)}</span>
                  <span className="font-manrope text-sm opacity-30">•</span>
                  <span className="font-manrope text-sm font-medium">{post.readTime} lesning</span>
                </div>
                <h2 className="font-syne font-bold text-2xl text-primary mb-4 group-hover:text-accent transition-colors duration-300 leading-tight">
                  {post.title}
                </h2>
                <p className="font-manrope text-muted-foreground text-sm leading-relaxed mb-8 flex-grow">
                  {post.description}
                </p>
                <span className="inline-flex items-center gap-2 font-syne font-bold text-xs uppercase tracking-wider text-accent group-hover:gap-4 transition-all duration-300">
                  Les hele artikkelen
                  <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
